// Module
var code = "<div class=\"c-divider\" :style=\"`${color && `background-color: ${color}`}`\"></div> ";
// Exports
export default code;